// Floor lines per placement scene (world units) — where the back wall meets the floor.
// Natalka's feet walk along the same line. A placed FLOOR item's bottom edge may not go
// above it (nothing gets "hung" on the wall by accident) and a WALL item's bottom edge
// may not go below it (no clocks on the floor). The server enforces the same rule from
// backend/app/game/floors.json; this constant must stay deep-equal to that file (pinned by
// floors.test.mjs — kept as a JS literal so plain `node --test` can import it).
export const FLOORS = {
  home: { polyline: [[2, 550], [489, 453], [1125, 481], [1279, 590]] },
  second_floor: { polyline: [[3, 662], [439, 499], [965, 501], [1279, 597]] },
  kitchen: { min_y: 475 },
  salon: { min_y: 475 },
};

// Wall / ceiling items (mirrors backend floors.WALL_ITEMS).
export const WALL_ITEMS = {
  furniture: new Set(['zegar', 'obraz']),
  decoration: new Set(['plakat', 'zyrandol', 'girlanda']),
  buda: new Set(),
};
export const FLOOR_EXEMPT = WALL_ITEMS;   // older name

export function isFloorItem(type, item) {
  return !(WALL_ITEMS[type]?.has(item));
}

// Floor line y at world x for a backend scene id ('home', 'kitchen', …), or null = no rule.
export function floorYAt(scene, x) {
  const spec = FLOORS[scene];
  if (!spec) return null;
  if (typeof spec.min_y === 'number') return spec.min_y;
  const pts = spec.polyline;
  if (!pts || pts.length === 0) return null;
  if (x <= pts[0][0]) return pts[0][1];
  if (x >= pts[pts.length - 1][0]) return pts[pts.length - 1][1];
  for (let i = 0; i < pts.length - 1; i++) {
    const [x1, y1] = pts[i];
    const [x2, y2] = pts[i + 1];
    if (x >= x1 && x <= x2) {
      const t = x2 === x1 ? 0 : (x - x1) / (x2 - x1);
      return y1 + (y2 - y1) * t;
    }
  }
  return pts[0][1];
}

// The centre y a placement preview/drag should snap to, given the sprite's on-screen
// height: floor items keep their bottom edge on or below the line, wall items on or
// above it; scenes without a floor rule return y unchanged.
export function clampPlacementY(scene, type, item, x, y, height = 0) {
  const line = floorYAt(scene, x);
  if (line === null) return y;
  const centreOnLine = line - height / 2;
  return isFloorItem(type, item) ? Math.max(centreOnLine, y) : Math.min(centreOnLine, y);
}
